import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../../Assets/CSS/Styles.scss";
import { API_BASE_URL } from '../../config';
export default function NewsDetail() {
  const { id } = useParams();
  const [newsArticle, setNewsArticle] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/blogs/${id}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to load news");
        }
        return res.json();
      })
      .then((data) => setNewsArticle(data))
      .catch((err) => setError(err.message));
  }, [id]);

  if (error) {
    return <div className="text-center text-red-500 mt-10">{error}</div>;
  }

  if (!newsArticle) {
    return <div className="text-center text-gray-500 mt-10">Loading...</div>;
  }

  return (
   <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-8 md:py-12 max-w-4xl mt-8 sm:mt-12 md:mt-16 mt60">
  {/* Card Container */}
  <div className="bg-white rounded-lg md:rounded-xl shadow-lg md:shadow-2xl overflow-hidden transition-all duration-300 hover:shadow-xl md:hover:shadow-3xl">
    {/* Image with responsive height */}
    {newsArticle.image && (
      <div className="relative">
        <img
          src={`${API_BASE_URL}/uploads/${newsArticle.image}`}
          alt={newsArticle.title}
          className="w-full h-48 sm:h-64 md:h-80 lg:h-96 object-cover shadow-sm md:shadow-md rounded-t-lg md:rounded-t-xl"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
      </div>
    )}

    {/* Card Body with responsive padding */}
    <div className="p-4 sm:p-6 md:p-8">
      {/* Responsive title */}
      <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2 sm:mb-3 text-gray-800 [text-shadow:_0_1px_1px_rgb(0_0_0_/_0.1)] md:[text-shadow:_0_1px_2px_rgb(0_0_0_/_0.1)]">
        {newsArticle.title}
      </h1>

      {/* Date + Author with responsive layout */}
      <div className="flex flex-wrap items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
        <span className="text-xs sm:text-sm text-gray-500 px-2 sm:px-3 py-1 bg-gray-100 rounded-full">
          {new Date(newsArticle.publishDate).toLocaleDateString()}
        </span>
        <span className="text-gray-400 hidden sm:block">•</span>
        <span className="text-xs sm:text-sm text-gray-500 px-2 sm:px-3 py-1 bg-gray-100 rounded-full">
          {newsArticle.author || "Unknown Author"}
        </span>
      </div>

      {/* Overview with responsive text */}
      {newsArticle.overview && (
        <div className="bg-blue-50 p-4 sm:p-6 rounded-lg mb-6 shadow-inner border border-blue-100">
          <p className="text-sm sm:text-base text-gray-700">{newsArticle.overview}</p>
        </div>
      )}

      {/* Full Sections with responsive spacing */}
      {newsArticle.sections?.length > 0 && (
        <div className="space-y-4 sm:space-y-6">
          {newsArticle.sections.map((section, index) => (
            <div 
              key={index} 
              className="pb-4 sm:pb-6 border-b p-3 sm:p-4 transition-all duration-200 hover:bg-gray-50/50 hover:shadow-xs sm:hover:shadow-sm rounded-md sm:rounded-lg"
            >
              {section.title && (
                <h2 className="text-xl sm:text-2xl font-semibold mb-2 sm:mb-3 text-gray-800 [text-shadow:_0_1px_1px_rgb(0_0_0_/_0.05)]">
                  {section.title}
                </h2>
              )}
              {section.description && (
                <p className="text-sm sm:text-base text-gray-700 mb-3 sm:mb-4">
                  {section.description}
                </p>
              )}
              {section.points && section.points.length > 0 && (
                <ul className="list-disc ml-4 sm:ml-6 space-y-1 sm:space-y-2 text-sm sm:text-base text-gray-700 marker:text-blue-400">
                  {section.points.map((point, idx) => (
                    <li 
                      key={idx} 
                      className="pl-1 sm:pl-2 hover:pl-2 sm:hover:pl-3 transition-all duration-150"
                    >
                      {point}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
</div>
  );
}
